export default __webpack_public_path__ + "static/media/821.5c06f9fd.png";